module.exports = __webpack_public_path__ + "static/media/vk-logo.f1cef0f0.svg";